import React, { Component } from "react";
import PropTypes from "prop-types";
import Button from "./Button";
import styles from "./Modal.module.css";

/* Modal */

export class Modal extends Component {
  render() {
    const { children } = this.props;

    return (
      <div className={styles.modalBg}>
        <div className={styles.modal}>{children}</div>
      </div>
    );
  }
}

Modal.propTypes = {
  children: PropTypes.node,
};

/* Modal Header */

export class ModalHeader extends Component {
  render() {
    const { children } = this.props;

    return <div className={styles.modalHeader}>{children}</div>;
  }
}

ModalHeader.propTypes = {
  children: PropTypes.node,
};

/* Modal Content */

export class ModalContent extends Component {
  render() {
    const { children } = this.props;

    return <div className={styles.modalContent}>{children}</div>;
  }
}

ModalContent.propTypes = {
  children: PropTypes.node,
};

/* Modal Footer */

export class ModalFooter extends Component {
  render() {
    const { children } = this.props;

    return <div className={styles.modalFooter}>{children}</div>;
  }
}

ModalFooter.propTypes = {
  children: PropTypes.node,
};

export class ConfirmModal extends Component {
  constructor(props) {
    super(props);
    this.renderButton = this.renderButton.bind(this);
  }

  renderButton(button) {
    const { label, type, onClick } = button;
    return (
      <Button type={type} onClick={onClick}>
        {label}
      </Button>
    );
  }

  render() {
    const { title, description, buttons } = this.props;

    return (
      <Modal>
        <ModalHeader>{title}</ModalHeader>
        <ModalContent>
          <p>{description}</p>
        </ModalContent>
        <ModalFooter>
          <Button type="link" onClick={this.props.closeModal}>
            Cancel
          </Button>
          {buttons.map(this.renderButton)}
        </ModalFooter>
      </Modal>
    );
  }
}
